export default __webpack_public_path__ + "static/media/dark16.984d1967.png";